import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const MemberNewMeetingNotifCover = ({ notification }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={
        rtl ? 'لديك ملاحظة اجتماع جديدة' : 'You have a new meeting notice!'
      }
    />
  )
}

export default MemberNewMeetingNotifCover
